import { FlexRow, TokenAmount } from '@xylabs/sdk-react'

import { useAuction, useMinimumBid } from '../../Contexts'
import { shiftBase10 } from '../../shiftBase10'
import { Property } from '../Property'

const MinimumBidProperty: React.FC = () => {
  const { auction } = useAuction()
  const minimumBid = useMinimumBid()

  return auction ? (
    <Property title="Minimum Bid" value={shiftBase10(minimumBid, -18)?.toString(10)}>
      <FlexRow busy={minimumBid === undefined}>
        <TokenAmount amount={minimumBid} />
      </FlexRow>
    </Property>
  ) : null
}

export default MinimumBidProperty
